exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-error{margin:5px 0 0;color:#f02;font-family:ToyotaType-Book,sans-serif;font-size:10px;font-weight:400;line-height:16px}@media only screen and (min-width:1279px){.field-error{font-size:16px;font-weight:400;line-height:18px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/home/vintagp/www/toyota_dreamcar/front/assets","/static":"/home/vintagp/www/toyota_dreamcar/front/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b75c28f2","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/home/vintagp/www/toyota_dreamcar/front/assets/scss/util/_mixins.scss","/home/vintagp/www/toyota_dreamcar/front/assets/scss/util/_functions.scss","/home/vintagp/www/toyota_dreamcar/front/assets/scss/util/_variables.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/_UI/BaseErrorMessage.vue
// module id = qln9
// module chunks = 13